import React from "react";
import EmailBuilderEmbed from "./EmailBuilder";

const EmailBuilderPage = () => {
  return (
    <div>
      <EmailBuilderEmbed />
    </div>
  );
};

export default EmailBuilderPage;
